import React, { useEffect }  from 'react'
import ComplexSaleTemplatesList from './ComplexSaleTemplatesList'
import HeaderIconButton from '../../components/HeaderIconButton'

export default function ComplexSaleTemplatesScreen({ navigation }) {

  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <HeaderIconButton
          onPress={() => {
            navigation.navigate('ComplexSaleDetail', { detail: null, editTemplateMode: true })
          }}
          iconName='plus-outline'
        />
      ),
    })
  }, [])

  const onItemPress = (item) => {
    navigation.navigate('ComplexSaleDetail', { detail: item, editTemplateMode: true })
  }

  return (
    <ComplexSaleTemplatesList onItemPress={onItemPress} showEmptyTemplate={false} />
  )
}
